import { gql } from "@apollo/client";

export const categorySelectionQuery = gql`
    query CategorySelection($brandId: ID!) {
        models(filter: { brand: { equal: $brandId }, isWpArticle: { equal: false }, parent: { equal: null }, hasVisibleDescendants: true }) {
            nodes {
                id
                description
                assetPath
                children {
                    id
                }
            }
            totalCount
        }
    }
`;
